// extracted by mini-css-extract-plugin
export default {"icon":"AddIcon_icon__VpOZR"};